// src/App.jsx
import React from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { Provider } from 'react-redux';
import { ThemeProvider } from '@mui/material/styles';
import CssBaseline from '@mui/material/CssBaseline';
import store from './store';
import theme from './utils/theme';

import ProtectedRoute from './components/ProtectedRoute';
import Layout from './components/Layout';
import LoginPage from './pages/LoginPage';
import DashboardPage from './pages/DashboardPage';
import TasksPage from './pages/TasksDashboardPage';
import ActivityPage from './pages/activity/ActivityPage';
import UsersPage from './pages/UsersPage';
import UserLogsPage from './pages/UserLogsPage';
import TagBoardPage from './pages/TagBoardPage';

import TaskDefinitionsPage from './pages/TaskDefinitionsPage';
import TaskDefinitionEditorPage from './pages/TaskDefinitionEditorPage';

function AdminApp() {
  return (
    <Layout>
      <Routes>
        {/* <Route path="/dashboard" element={<DashboardPage />} /> */}
        <Route path="/activity" element={<ActivityPage />} />
        <Route path="/tasks" element={<TasksPage />} />
        <Route path="/taskforms" element={<TaskDefinitionsPage />} />
        <Route path="/taskforms/new"      element={<TaskDefinitionEditorPage />} />
        <Route path="/taskforms/:id" element={<TaskDefinitionEditorPage />} />
        <Route path="/tagboard" element={<TagBoardPage />} />

        {/* <Route path="/tasks/trash" element={<TasksPage trashMode />} />
        <Route path="/tasks/export" element={<TasksPage />} />
        <Route path="/analytics" element={<DashboardPage />} /> */}
        <Route path="/users" element={<UsersPage />} />
        <Route path="/userlogs" element={<UserLogsPage />} />

        {/* <Route path="/settings" element={<div style={{ color: '#7a9bbf', padding: 24 }}>Settings — coming soon</div>} /> */}
        <Route path="*" element={<Navigate to="/activity" replace />} />
      </Routes>
    </Layout>
  );
}

export default function App() {
  return (
    <Provider store={store}>
      <ThemeProvider theme={theme}>
        <CssBaseline />
        <BrowserRouter>
          <Routes>
            <Route path="/login" element={<LoginPage />} />
            <Route
              path="/*"
              element={
                <ProtectedRoute>
                  <AdminApp />
                </ProtectedRoute>
              }
            />
          </Routes>
        </BrowserRouter>
      </ThemeProvider>
    </Provider>
  );
}
